import React from "react";
import "../Pages/CSS/footer.css";
import star from "../Images/assets/asset_star_blue.png"

function Footer() {
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const y = el.getBoundingClientRect().top + window.pageYOffset - 128;
    window.scrollTo({ top: y, behavior: "smooth" });
  };

  return (
      <footer className="footer">
        <div className="footer-container-1">
            <img className="star-1" src={star} alt="star"/>
            <p className="email">
              <a className="email-link" href="mailto:harshkaranwal2000@gmail.com">
                harshkaranwal2000@gmail.com
              </a>
            </p>
        </div>
        <div className="footer-container-2">
            <div className="footer-container-2a">
                <img className="star-2" src={star} alt="star"/>
                <button
                  type="button"
                  className="footer-menu-link"
                  onClick={() => scrollToSection("about")}
                >
                  About
                </button>
            </div>
            <div className="footer-container-2a">
                <img className="star-2" src={star} alt="star"/>
                <button
                  type="button"
                  className="footer-menu-link"
                  onClick={() => scrollToSection("work")}
                >
                  Work
                </button>
            </div>
            <div className="footer-container-2a">
                <img className="star-2" src={star} alt="star"/>
                <button
                  type="button"
                  className="footer-menu-link"
                  onClick={() => scrollToSection("connect")}
                >
                  Contact
                </button>
            </div>
        </div>
        <div className="footer-container-3">
            <p>Ready to get your project started?<br/> Drop me an <a href="mailto:harshkaranwal2000@gmail.com">e-mail</a> or <a href="/">text me</a> on my <a href="/">socials</a>. I am open to collaborate with creative minds.</p>
        </div>
        <div className="footer-container-4">
            <p className="footer-text">Terms & Conditions | Privacy Policy</p>
            <p className="footer-text">© 2025 Harsh Karanwal. All rights reserved.</p>
        </div>
    </footer>
  );
}

export default Footer;
